import { css } from "styled-components";
import theme from "package-common-react/lib/style/theme";

export default {
  ...theme,
  color: {
    ...theme.color,
    standard: '#100F37',
    background: '#F7CD00',

    primary: '#E20714',
//    primaryText: '#FFF',
    secondary: '#576E99',
//    secondaryText: '#FFF',
    success: '#F7CD00',
//    successText: '#FFF',
    error: '#E20714',
//    errorText: '#FFF',

    bullet: '#E20714',
//    bulletText: '#FFF',

    blue: '#193D83',
    blueText: '#FFF',
    red: '#E20714',
    redText: '#FFF',
    yellow: '#F7CD00',
  },
  style: {
    ...theme.style,
    answerAlignment: css`
      align-items: flex-start;
      justify-content: stretch;
    `
  }
};


// WEBPACK FOOTER //
// ./src/theme.js